export default {
    complaints: [],
    complaintsLoading: false,
    complaintTypes: [],
    complaintStatuses: [],
    productionDepartments: [],
    users: [],
    complaintMaterials: [],
    complaintUnits: [],
    complaintAttachments: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
    productionNumbersList: [],
    orderNumbers: [],
    errors: [],
    uploadCancelTokens: []
}

function setInitialFilters() {
    return {
        complaintStatus : [],
        complaintProductionDepartment: null,
        complaintType_id: null,
        createdAt__gte: null,
        createdAt__lte: null,
        assigned: null,
        creator: null,
        complaintPackageNumber: null,
        responsiblePerson_ids: []
    }
}